import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Aggressive HMR support for real-time updates
if (import.meta.hot) {
  // Accept all updates immediately
  import.meta.hot.accept();
  
  // Force immediate re-render on any update
  import.meta.hot.on('vite:beforeUpdate', () => {
    console.log('🔄 Updating components...');
  });
  
  // Handle HMR errors
  import.meta.hot.on('vite:error', (data) => {
    console.error('HMR Error:', data);
  });
  
  // Force reload on full reload
  import.meta.hot.on('vite:beforeFullReload', () => {
    console.log('🔄 Full reload triggered...');
  });
}

// Render the app
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
};

renderApp();

// Handle HMR updates with immediate re-render
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    // Cleanup before HMR update
    root.unmount();
  });
  
  // Force immediate update on any change
  import.meta.hot.on('vite:beforeUpdate', () => {
    // Re-render immediately
    renderApp();
  });
}